
import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import { displayColorBySituation, backofficeRoute } from '@/utils/common'
import { Historico, HistoricoSolicitacao, ProtocolHistory, SituacaoEnum } from '@/types/_'
import moment from 'moment'
import ModalHistoricoSolicitacaoModule from './modal-historico-solicitacao.module'

@Component({
  ...ModalHistoricoSolicitacaoModule,
})
export default class ComponentModalHistoricoSolicitacao extends Vue {
  @Prop() tipoUsuario: string

  activeTab: 'tab-0' | 'tab-1' = 'tab-0'

  @Watch('activeTab')
  async onTabChange(currentTab) {
    const { surgerySolicitationId } = this.getHistoricoSolicitacaoStore

    if (currentTab === 'tab-1') {
      await this.getHistoricoSolicitacaoStore.getProtocolHistory(surgerySolicitationId)
    } else {
      this.getHistoricoSolicitacaoStore.resetProtocolHistory()
    }
  }

  close() {
    this.getShowModalHistorico = false
  }

  get backofficeArea(): string | null | undefined {
    return backofficeRoute()
  }

  get history() {
    return this.getHistoricoSolicitacaoStore.historicoSolicitacao
  }

  get protocolHistory() {
    return this.getHistoricoSolicitacaoStore.protocolHistory
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getShowModalHistorico() {
    return this.getHistoricoSolicitacaoStore.modal.historicoSolicitacao
  }

  set getShowModalHistorico(value: boolean) {
    if (!value) {
      this.scrollToTop(document)
    }
    this.getHistoricoSolicitacaoStore.setShowModalHistoricoSolicitacao(value)
    this.getHistoricoSolicitacaoStore.clearHistoricoSolicitacao()
    this.activeTab = 'tab-0'
    this.getHistoricoSolicitacaoStore.resetProtocolHistory()
    this.getHistoricoSolicitacaoStore.resetSurgerySolicitationId()
  }

  getHistoryLogType(history: HistoricoSolicitacao): 'doctorUpdate' | 'default' {
    const { tipoLog: logType } = history

    switch (logType.key) {
      case 'AlteracaoDeMedico':
        return 'doctorUpdate'
      case 'Status':
        return 'default'

      default:
        return 'default'
    }
  }

  getStatusDisplay(history: HistoricoSolicitacao): string {
    const { status, tipoLog } = history
    if (tipoLog.key === 'Status') {
      if (status.display === 'Incompleta') {
        return 'Editado'
      }
      return status.display
    }
    return tipoLog.display
  }

  scrollToTop(document: Document | null | undefined) {
    const d = document
    d!.querySelector('.l_content')!.scrollTop = 0
  }

  formatData(date: Date | string) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  parseFidelizationStatus(userName) {
    return `Solicitação alterada por ${userName}`
  }

  parseLogTypeDoctorUpdate(userName) {
    return `Solicitação alterada por ${userName}`
  }

  formatTexto(event: HistoricoSolicitacao) {
    switch (event.status.key) {
      case SituacaoEnum.PreAgendamento:
        return `Enviada ao pré-agendamento por ${event.usuarioNome}`

      case SituacaoEnum.RevisaoCirurgica:
        return `Enviada à revisão por ${event.usuarioNome}`

      case SituacaoEnum.RevisaoCirurgicaAutorizacao:
        return `Enviada à revisão por ${event.usuarioNome}`

      case SituacaoEnum.Enviado:
        return `Solicitação enviada por ${event.usuarioNome}`

      case SituacaoEnum.Incompleta:
        return `Solicitação alterada por ${event.usuarioNome}`

      case SituacaoEnum.EmTriagem:
        return `Triagem realizada por ${event.usuarioNome}`

      case SituacaoEnum.AlteracaoDeCarater:
        return `Alteração de caráter realizada por ${event.usuarioNome}`

      case SituacaoEnum.EmAutorizacao:
        return `Encaminhada autorização por ${event.usuarioNome}`

      case SituacaoEnum.AnalisePreAutorizacao:
        return `Enviado para análise por ${event.usuarioNome}`

      case SituacaoEnum.AnalisePreCotacao:
        return `Enviado para análise por ${event.usuarioNome}`

      case SituacaoEnum.AnalisePosCotacao:
        return `Enviado para análise por ${event.usuarioNome}`

      case SituacaoEnum.EmCotacao:
        return `Enviado para cotação por ${event.usuarioNome}`

      case SituacaoEnum.Pendente:
        return `Aberta pendência por ${event.usuarioNome}`

      case SituacaoEnum.PendenciaRespondida:
        return `Pendência respondida por ${event.usuarioNome}`

      case SituacaoEnum.AguardandoOperadora:
        return `Aguardando autorização por ${event.usuarioNome}`

      case SituacaoEnum.AutorizadaParcial:
        return `Autorizada parcialmente por ${event.usuarioNome}`

      case SituacaoEnum.AutorizadaAceitaMedico:
        return `Aceita pelo médico ${event.usuarioNome}`

      case SituacaoEnum.AceitaPeloMedico:
        return `Aceita pelo médico ${event.usuarioNome}`

      case SituacaoEnum.EmAnalise:
        return `Posta em análise por ${event.usuarioNome}`

      case SituacaoEnum.ContestacaoMedica:
        return `Aberta contestação médica por ${event.usuarioNome}`

      case SituacaoEnum.ContestacaoPendente:
        return `Contestação respondida por ${event.usuarioNome}`

      case SituacaoEnum.CancelamentoSolicitado:
        return `Cancelamento solicitado por ${event.usuarioNome}`

      case SituacaoEnum.Cancelada:
        return `Cancelado por ${event.usuarioNome}`

      case SituacaoEnum.Autorizada:
        return `Autorizada por ${event.usuarioNome}`

      case SituacaoEnum.AguardandoSuprimentos:
        return `Enviado para suprimentos por ${event.usuarioNome}`

      default:
        return `${event.usuarioNome}`
    }
  }

  formatMotivoCancelamento(motivo: string) {
    return motivo || 'Não informado'
  }

  getHistoryColorParameter(history: HistoricoSolicitacao): string {
    const { status, tipoLog } = history
    if (tipoLog.key === 'Status') {
      return status.key
    }
    return tipoLog.key
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }

  get historicoAlteracoesSolicitacao() {
    return this.getHistoricoSolicitacaoStore.historicoAlteracoesSolicitacao
  }
}
